import { QuizQuestion } from "../models/quiz/QuizQuestionModel";
import { QuizCategory } from "../models/quiz/QuizCategoryModel";

const conditionalQuestions: QuizQuestion[] = [
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Elige la mejor respuesta: 'Si hubieras venido antes, ___ la película.'",
        options: ["verías", "habrías visto", "viste", "verás"],
        correctAnswerIndex: 1,
        explanation: "'Habrías visto' es la forma correcta porque se usa el condicional perfecto en una oración condicional del tercer tipo, refiriéndose a una acción que no ocurrió en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Completa la oración: 'Si ___ dinero, viajaría por el mundo.'",
        options: ["tengo", "tenía", "tuviera", "tuve"],
        correctAnswerIndex: 2,
        explanation: "'Tuviera' es la forma correcta porque se usa el imperfecto de subjuntivo en una oración condicional de tipo 2, que expresa una situación hipotética e irreal en el presente."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si estudias más, ___ mejores resultados.'",
        options: ["tienes", "tendrás", "tuviste", "tendrías"],
        correctAnswerIndex: 1,
        explanation: "'Tendrás' es la forma correcta porque se usa el futuro en la oración condicional de tipo 1, que expresa una consecuencia probable si la condición se cumple en el presente."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Completa la frase: 'Si ___ tiempo, iríamos al cine.'",
        options: ["tengo", "teníamos", "tuviéramos", "tuvo"],
        correctAnswerIndex: 2,
        explanation: "'Tuviéramos' es el imperfecto de subjuntivo, usado en una condicional irreal."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si ellos ___ más tarde, habríamos ido al evento.'",
        options: ["llegaron", "llegaran", "llegan", "llegaron"],
        correctAnswerIndex: 1,
        explanation: "'Llegaran' es el imperfecto de subjuntivo, utilizado en una condición hipotética."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Elige la mejor opción: 'Si tú ___ avisado, habríamos preparado algo.'",
        options: ["me hubieras", "me hayas", "me hubiera", "me avisas"],
        correctAnswerIndex: 0,
        explanation: "'Me hubieras avisado' es el pluscuamperfecto de subjuntivo, usado para situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Completa la oración: 'Si tú ___ más paciencia, habría sido más fácil resolver el problema.'",
        options: ["tienes", "tenías", "tuviste", "hubieras tenido"],
        correctAnswerIndex: 3,
        explanation: "Esta es una oración condicional que expresa una situación hipotética en el pasado que no ocurrió."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Elige la opción correcta: 'Si ella ___ mejor, habría aprobado el examen.'",
        options: ["estudió", "hubiera estudiado", "estudia", "estudiaba"],
        correctAnswerIndex: 1,
        explanation: "'Hubiera estudiado' es el pluscuamperfecto de subjuntivo, usado en una condición irreal en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si nosotros ___ terminado la reunión antes, habríamos podido salir.'",
        options: ["habríamos", "hubiéramos", "teníamos", "tenemos"],
        correctAnswerIndex: 1,
        explanation: "'Hubiéramos terminado' es el pluscuamperfecto de subjuntivo, usado para expresar una acción condicional en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Elige la mejor respuesta: 'Si tú ___ hablado con él, habrías resuelto el problema.'",
        options: ["hubieras", "habrías", "hablaste", "hablas"],
        correctAnswerIndex: 0,
        explanation: "'Hubieras hablado' es el pluscuamperfecto de subjuntivo, usado para una situación hipotética que no ocurrió."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Completa la frase: 'Si tú ___ temprano, no habrías perdido el tren.'",
        options: ["llegaste", "llegaras", "llegaste", "llegar"],
        correctAnswerIndex: 1,
        explanation: "'Llegaras' es el imperfecto de subjuntivo, usado en una condición hipotética en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si ellos ___ estudiado más, habrían obtenido mejores notas.'",
        options: ["habrían", "hubieran", "estudiaron", "estudian"],
        correctAnswerIndex: 1,
        explanation: "'Hubieran estudiado' es el pluscuamperfecto de subjuntivo, usado para hablar de situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si ella ___ (hablar) más alto, todos la habrían entendido.'",
        options: ["habló", "hablo", "hablaba", "hablase"],
        correctAnswerIndex: 3,
        explanation: "'Hablase' es el imperfecto de subjuntivo, usado para situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si ___ más dinero, compraría una casa.'",
        options: ["tengo", "tuve", "tuviera", "tenía"],
        correctAnswerIndex: 2,
        explanation: "'Tuviera' es el imperfecto de subjuntivo, usado para situaciones hipotéticas o poco probables."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Completa la oración: 'Si tú ___ terminado el proyecto a tiempo, habrías recibido un premio.'",
        options: ["habrías", "terminas", "hubieras", "terminas"],
        correctAnswerIndex: 2,
        explanation: "'Hubieras terminado' es el pluscuamperfecto de subjuntivo, empleado en situaciones hipotéticas en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si nosotros ___ (saber) la respuesta, te la habríamos dicho.'",
        options: ["supimos", "supiéramos", "sabíamos", "supiese"],
        correctAnswerIndex: 1,
        explanation: "'Supiéramos' es el imperfecto de subjuntivo, que expresa una situación hipotética no realizada en el pasado."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si ellos ___ (vivir) cerca de aquí, vendrían a visitarnos más a menudo.'",
        options: ["vivieron", "vivieran", "vivían", "viviese"],
        correctAnswerIndex: 1,
        explanation: "'Vivieran' es el imperfecto de subjuntivo, usado en una condición hipotética que no se cumplió."
    },
    {
        category: QuizCategory.CONDITIONAL,
        questionText: "Selecciona la opción correcta: 'Si tú ___ (hacer) los deberes, habrías aprobado el examen.'",
        options: ["hiciste", "hacías", "hicieras", "hiciese"],
        correctAnswerIndex: 2,
        explanation: "'Hicieras' es el imperfecto de subjuntivo, usado para expresar una condición no realizada en el pasado."
    }
];

export default conditionalQuestions;